import React from "react";
import PropTypes from "prop-types";

function SelectOptions({ name = "", options }) {
    if (!options.length) {
        return <div>THERE ARE NO OPTIONS!</div>;
    }

    const opts = options
        .map((opt) => {
            if (typeof opt === "object") {
                return opt;
            }
            return {
                value: opt,
                label: opt
            };
        })
        .filter(
            ({ value, label }) =>
                value !== undefined &&
                value !== null &&
                label !== undefined &&
                label !== null
        );

    return (
        <>
            {opts.map(({ value, label, disabled }) => (
                <option
                    key={`${name}-${value}`}
                    value={value}
                    disabled={disabled === true}
                >
                    {label}
                </option>
            ))}
        </>
    );
}

SelectOptions.defaultProps = {
    name: ""
};

SelectOptions.propTypes = {
    options: PropTypes.array.isRequired,
    name: PropTypes.string
};

export { SelectOptions };
